import BagIcon from '@icons/BagIcon'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { CART_URL } from '../../../urls'
import { SubmitButton } from './common'

const HIDE_AFTER_MS = 5000

interface Props {
  onClose(): void
}

// Shown over the panel's form (which keeps the panel's height) after adding to the cart, then the panel closes.
// The countdown bar at the bottom drives the closing: it pauses while hovered, and stops for good on a touch.
const AddedToCartNotice: React.FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()
  const history = useHistory()
  const [touched, setTouched] = useState(false)

  return (
    <div
      className={`product-card-added ${touched ? 'product-card-added--paused' : ''}`}
      role='status'
      onTouchStart={() => setTouched(true)}
    >
      <p className='product-card-added__title'>{t('productCard.addedToCart', 'Added to cart!')}</p>
      <SubmitButton icon={<BagIcon viewBox='0 0 21 26' />} onClick={() => history.push(CART_URL)}>
        {t('productCard.goToShoppingBag', 'Go to Shopping Bag')}
      </SubmitButton>
      <div
        className='product-card-added__countdown'
        style={{ animationDuration: `${HIDE_AFTER_MS}ms` }}
        onAnimationEnd={onClose}
      />
    </div>
  )
}

export default AddedToCartNotice
